import { Component, OnInit, HostListener, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { LoadingService } from '@app/core/services';
import { IFRAME_URL } from './cred-card-iframe.config';


@Component({
  selector: 'app-credit-card-iframe',
  templateUrl: './credit-card-iframe.component.html',
  styleUrls: ['./credit-card-iframe.component.css']
})
export class CreditCardIframeComponent implements OnInit {

  @Input('creditCardGroup') 
  public creditCardForm: FormGroup;

  iFrameLoaded: boolean = false;
  showLoader: boolean = true;
  //public iframe: string = 'https://fts.cardconnect.com:6443/itoke/ajax-tokenizer.html?css=.error,.error:focus{ border-color: red;}body { margin: 0; } input{ box-sizing: border-box; width: 100%25; font-family: Arial; font-size: 14px; color: %23666; display: block; background: white; border: 2px solid %23c2c2c2; border-radius: 4px; padding: 12px; outline: none;} input:focus { border: 2px solid %23176CE7; outline: none;}&invalidinputevent=true';
  public iframe: string = IFRAME_URL;
  time;
  constructor(private _loadingService: LoadingService) {}

  ngOnInit() {
    // this.time = Date.now()
    // document.getElementById('ccFrame').onload = function() {
    //   this.iframeLoaded();
    // }.bind(this);

  }

  // iframeLoaded() {
  //   console.log("Iframe loaded, can check fields now")
  //   console.log("Load time:", Date.now() - this.time)
  //   var frame: any = document.getElementById('ccFrame')
  //   this.showLoader = false;
  //   console.log(frame.width)
  //   try{
  //     var doc = frame.contentDocument || frame.contentWindow.document;
  //     console.log(doc)
  //     var html = doc.body.innerHTML;
  //     console.log(html)
  //     //doc.style.height = doc.style.scrollHeight
  //     //did not load iframe
  //     console.log('did not load')
  //   } catch(err){
  //     //iframe loaded
  //     console.log(err)
  //   }
  //   //frame.style.height = frame.contentWindow.document.documentElement.scrollHeight + 'px';
    
  // }

  private _updateData(data: any): void {
    //console.log("data:", data);
    if (data.message && data.expiry) {
      console.log('token:', data.message)
      console.log('year:', data.expiry.substring(0,4))
      console.log('month:', data.expiry.substring(4))
      this.creditCardForm.controls.CardNumber.patchValue(data.message);
      this.creditCardForm.controls.ExpireYear.patchValue(data.expiry.substring(0,4))
      this.creditCardForm.controls.ExpireMonth.patchValue(data.expiry.substring(4))
      this.creditCardForm.controls.CVV.patchValue("9999")
    } else {
      this.creditCardForm.controls.CardNumber.patchValue("");
      this.creditCardForm.controls.ExpireYear.patchValue("")
      this.creditCardForm.controls.ExpireMonth.patchValue("")
      this.creditCardForm.controls.CVV.patchValue("")
    }
  }

  // Binds to the CardConnect iframe message event
  @HostListener('window:message', ['$event'])
  tokenizationMessage($event) {
    //console.log($event);
    if(typeof $event.data == 'string' && $event.origin.includes("https://fts.cardconnect.com")) {  
      //console.log($event.data)   
      var json = JSON.parse($event.data);
      //console.log(json);
      this._updateData(json);
    }
  }

}



// WEBPACK FOOTER //
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/component/credit-card-iframe/credit-card-iframe.component.ts